// extracted by mini-css-extract-plugin
export default {"wrap":"wrap-kL1e","avatar":"avatar-pzhh"};